export default function Policies() {
  return (
    <section className="max-w-3xl mx-auto px-4 py-12 space-y-4">
      <h1 className="text-3xl font-semibold tracking-tight">Policies</h1>
      <ul className="list-disc pl-6 text-foreground/80 space-y-2">
        <li>No smoking inside tents.</li>
        <li>Quiet hours 10pm–7am.</li>
        <li>Check‑in from 2pm; check‑out by 11am.</li>
        <li>Respect nature—leave no trace.</li>
      </ul>
    </section>
  );
}
